import { render, staticRenderFns } from "./privacy-text_de.vue?vue&type=template&id=4fc9eff9"
import script from "./privacy-text_de.vue?vue&type=script&lang=js"
export * from "./privacy-text_de.vue?vue&type=script&lang=js"
import style0 from "./privacy-text_de.vue?vue&type=style&index=0&id=4fc9eff9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports